module.exports = __webpack_public_path__ + "img/02-02_Acting with modesty.b88f0854.svg";